export default {
  profile: {
    welcomeBack: 'Welcome back, {{name}}',
    viewYourShop: 'View your shop',
    customizeYourProfile: 'Customize your profile',
  },
  earnings: {
    youveEarnedHtml: 'You\'ve earned %{tagOpen}%{totalEarnings}%{tagClose} on Reverb',
    fromReverbProtections: '%{tagOpen}%{accommodationsTotal}%{tagClose} from Reverb Protections or Safe Shipping Programs',
  },
  bumpStats: {
    title: 'Bumped Listings',
    usedTitle: 'Used Listings',
    brandNewTitle: 'New Listings',
    spent: 'Spent',
    sales: 'Sales',
    percentageSpent: 'Bump Spend %',
    views: 'Bump Views',
  },
  recentOrders: {
    mostRecentOrders: 'Most recent orders',
    viewAllOrders: 'View All Orders',
    printLabel: 'Print Label',
    getALabel: 'Get a Label',
    addTracking: 'Add Tracking',
  },
  recentOffers: {
    mostRecentOffers: 'Most recent offers',
    viewAllOffers: 'View All Offers',
    offer: 'Offer: ',
    counterOffer: 'Counter offer: ',
    from: 'from {{name}}',
    in: 'in {{address}}',
    expired: 'Expired',
    expires: 'Expires {{time}}',
    respond: 'Respond',
  },
  recentMessages: {
    mostRecentMessages: 'Most recent messages',
    viewAllMessages: 'View All Messages',
    unread: 'unread',
    respond: 'Respond',
  },
};
